import classNames from 'classnames';

const CardNumberDownloads = ({ nDownloads, expand }) => {
  const numberDownloadsClass = classNames({
    card__ndownload: !expand,
    'card__ndownload--expanded': expand,
  });

  return (
    <div className={numberDownloadsClass}>
      {expand && 'Nº Downloads: '} {nDownloads > 99 ? '99+' : nDownloads}
    </div>
  );
};

export default CardNumberDownloads;
